<template>
  <div
    class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12 max-w-xl min-w-full sm:min-w-30"
  >
    <h1 class="font-semibold text-2xl lg:text-3xl text-center mb-10">
      <slot name="header-title">
        Create Your Account
      </slot>
    </h1>
    <div class="text-center">
      <button @click="loginWithLinkedin">
        <img
          src="@/assets/images/ic_linkedin.svg"
          alt="BuildaBox Signup Page"
        />
      </button>
      <button @click="onFacebookLogin" class="mx-5">
        <img
          src="@/assets/images/ic_facebook.svg"
          alt="BuildaBox Signup Page"
        />
      </button>
      <button @click="loginWithTwitter">
        <img src="@/assets/images/ic_twitter.svg" alt="BuildaBox Signup Page" />
      </button>
    </div>
    <div class="sm:grid sm:grid-cols-2 mb-3 sm:gap-5 mt-8">
      <fieldset class="text-left mb-4 sm:mb-0">
        <label for="su_firstName" class="text-sm">First Name</label>
        <input
          type="text"
          class="input mt-2"
          id="su_firstName"
          v-model="firstName"
        />
      </fieldset>
      <fieldset class="text-left">
        <label for="su_lastName" class="text-sm">Last Name</label>
        <input
          type="text"
          class="input mt-2"
          id="su_lastName"
          v-model="lastName"
        />
      </fieldset>
    </div>
    <fieldset class="text-left mb-3">
      <label for="email" class="text-sm">Email</label>
      <input type="email" class="input mt-2" id="email" v-model="email" />
    </fieldset>
    <fieldset class="text-left mb-3">
      <label for="registerPassword" class="text-sm">Password</label>
      <input
        type="password"
        class="input mt-2"
        id="registerPassword"
        v-model="password"
      />
    </fieldset>
    <div class="text-left mb-4">
      <label for="passwordConfirmation" class="text-sm">Repeat password</label>
      <input
        type="password"
        class="input mt-2"
        id="passwordConfirmation"
        v-model="passwordConfirmation"
      />
    </div>
    <transition name="fade">
      <div class="text-canceled text-center text-xs mt-4" v-if="isError">
        {{
          errors.passwordConfirmation
            ? "Please, repeat your password correctly"
            : "\xa0"
        }}
        {{ errors.email ? "Email has already been taken" : "\xa0" }}
        {{ errors.message ? "Email has already been taken" : "\xa0" }}
      </div>
    </transition>
    <button
      :disabled="!canContinue || loading"
      class="w-full btn btn-primary font-semibold rounded-lg mt-4"
      @click="submit"
    >
      <span v-if="!loading">
        <slot name="button-title">
          Sign Up
        </slot>
      </span>
      <Spinner class="mx-auto" v-if="loading" />
    </button>
    <div class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import Spinner from "../Spinner";
import { Utils } from "@/utils";
import Api from "../../../api";
import { mapGetters } from "vuex";

const MIN_PASSWORD_LENGTH = 8;
const MIN_TEXT_FIELD_LENGTH = 2;

export default {
  components: {
    Spinner
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      passwordConfirmation: "",
      logRes: null,
      timer: null,
      loading: false,
      errors: {}
    };
  },
  props: {
    updateUserID: {
      required: false
    }
  },
  computed: {
    ...mapGetters(["redirectAfterAuthUrl"]),
    canContinue() {
      return !this.$v.$invalid;
    },
    isError() {
      return !Utils.isObjectEmpty(this.errors);
    }
  },
  validations: {
    firstName: {
      required,
      minLength: minLength(MIN_TEXT_FIELD_LENGTH)
    },
    lastName: {
      required,
      minLength: minLength(MIN_TEXT_FIELD_LENGTH)
    },
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(MIN_PASSWORD_LENGTH)
    },
    passwordConfirmation: {
      required,
      minLength: minLength(MIN_PASSWORD_LENGTH)
    }
  },
  created() {
    // Todo: make shared
    window.fbAsyncInit = function() {
      FB.init({
        appId: process.env.VUE_APP_FACEBOOK_APP_ID,
        xfbml: true,
        version: "v8.0",
        status: true
      });

      //This function should be here, inside window.fbAsyncInit
      FB.getLoginStatus(response => {
        this.logRes = { ...response };
      });
    };

    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  },
  methods: {
    async loginWithLinkedin() {
      const _params = new URLSearchParams({
        response_type: "code",
        client_id: process.env.VUE_APP_LINKEDIN_CLIENT_ID,
        redirect_uri: "https://buildabox.co/auth/sign-in/linkedin",
        state: "aRandomString",
        scope: "r_liteprofile r_emailaddress"
      });

      const oauthWindow = window.open(
        `https://www.linkedin.com/oauth/v2/authorization?${_params.toString()}`,
        "_blank",
        `resizable,scrollbars,status, width=400, height=600, left=400 top=200`
      );

      this.timer = setInterval(() => {
        if (oauthWindow.closed) {
          const token = localStorage.getItem("access_token");
          const user = localStorage.getItem("user");
          clearInterval(this.timer);

          if (token && user) {
            this.finishAuthentication(token, user);
          }
        }
      }, 500);
    },

    onFacebookLogin() {
      if (this.logRes) {
        this.loginWithFacebook(this.logRes.authResponse);
      } else {
        // eslint-disable-next-line
        FB.login(
          response => {
            if (response.authResponse) {
              this.loginWithFacebook(response.authResponse);
            }
          },
          { scope: "email", return_scopes: true }
        );
      }
    },

    async loginWithFacebook(authResponse) {
      try {
        this.loading = true;
        const response = await Api.loginWithFacebook({
          access_token: authResponse.accessToken
        });
        this.loading = false;
        this.authenticate(response);
        this.$emit("success");
      } catch (error) {
        this.loading = false;
        this.errors = error?.errors ? error.errors : error;
      }
    },

    async loginWithTwitter() {
      const oauthWindow = window.open(
        ``,
        "_blank",
        `resizable,scrollbars,status, width=400, height=600, left=400 top=200`
      );

      const params = {
        oauth_nonce: Date.now(),
        oauth_callback: "https://buildabox.co/auth/sign-in/twitter"
      };
      const result = await Api.initializeTwitterAuth(params);
      const urlParams = new URLSearchParams({
        ...result,
        oauth_callback: "https://buildabox.co/auth/sign-in/twitter"
      });
      oauthWindow.location.href = `https://api.twitter.com/oauth/authenticate?${urlParams.toString()}`;

      this.timer = setInterval(() => {
        if (oauthWindow.closed) {
          const token = localStorage.getItem("access_token");
          const user = localStorage.getItem("user");
          clearInterval(this.timer);

          if (token && user) {
            this.finishAuthentication(token, user);
          }
        }
      }, 500);
    },

    finishAuthentication(token, user) {
      this.authenticate({ user: JSON.parse(user), token });
      this.showGlobalSuccessMessage(
        "Welcome! We have sent you a verification email."
      );
      this.$emit("success");
    },

    async submit() {
      if (this.password !== this.passwordConfirmation) {
        this.errors = { passwordConfirmation: true };
        return;
      }

      this.loading = true;
      this.errors = {};
      try {
        if (this.updateUserID) {
          var response = await Api.registerUpdate({
            first_name: this.firstName.trim(),
            last_name: this.lastName.trim(),
            email: this.email.trim(),
            password: this.password,
            password_confirmation: this.passwordConfirmation,
            update_id: this.updateUserID
          });
        } else {
          var response = await Api.register({
            first_name: this.firstName.trim(),
            last_name: this.lastName.trim(),
            email: this.email.trim(),
            password: this.password,
            password_confirmation: this.passwordConfirmation,
          });
        }

        ;

        this.loading = false;
        this.authenticate(response);
        await this.showGlobalSuccessMessage(
          "Welcome! We have sent you a verification email. Please, verify your account"
        );

        this.$emit("success");

        this.$gtm.trackEvent({
          event: "signup",
          category: "User Managment",
          action: "signup",
          label: "User Signed Up",
          value: this.email
        });

        this.$analytics.fbq.event('CompleteRegistration')
        
      } catch (error) {
        this.loading = false;
        this.errors = error.response.data.errors ?? {
          message: "Signup failed with unknown error."
        };
      }
    },
    authenticate(userData) {
      this.$store.commit("SET_AUTH_DATA", userData);
    }
  }
};
</script>
